<template>
  <div class="blockDiv" :style='{height:(this.$store.state.windowHeight-this.$store.state.topBlockHeight)+"px",padding:this.$store.state.indexPadding+"px"}'>
    <div v-for="(item,index) in menuLists" :key="index">
        <div class="warp-nav-btn" :class='[item.id == menuID ? "active":""]'>
            <div class="nav-btn  common-items-center" @click="goUrl(item)">
                <div class="common-items-center">
                    <div v-if="item.id == menuID" class="imgBlockSvg">
                       <svg-icon :icon="item.image"/>
                    </div>
                    <div v-else class="imgBlockSvg">
                       <svg-icon :icon="item.image" class="wei"/>
                    </div>
                    <span class="text">{{item.name}}</span>
                </div>
                <i v-if="item.id == menuID" class="el-icon-arrow-down"/>
                <i v-else class="el-icon-arrow-right"/>
            </div>
            <div v-if="(item.id == menuID)">
                <div class="warp-list" >
                    <div v-for="(items,index) in item.childMBs" :key="index" class="btnBlock" :class='[item.childMBs.length-1==index?"btn":""]'>
                        <div class=" common-items-center textBtn"  :class='[items.id*1 == menuSonID*1 ? "active":"" ]'  @click="goUrlChild(items)">
                            <div v-if="items.id*1 == menuSonID*1" class="imgBlockSvg">
                                <svg-icon :icon="items.image"/>
                            </div>
                            <div v-else class="imgBlockSvg">
                                <svg-icon :icon="items.image" class="wei"/>
                            </div>
                            <span class="common-flexw  btn-name">{{items.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
  </div>
</template>
<script>
import {removal} from "@/utils/util"
    export default{
        data:()=>({
            menuID:1,
            menuSonID:0,
            menuLists:[],
            listMenuList:[],
            mark:"", 
        }),
        created(){
            setInterval(res=>{
                let objectItem = localStorage.getItem("menuBtnVav")
                    if(!objectItem){
                        return
                    }
                this.menuID = JSON.parse(objectItem).menuID
                this.menuSonID = JSON.parse(objectItem).menuSonID
                this.menuLists = JSON.parse(objectItem).menuList
                this.listMenuList = JSON.parse(objectItem).listMenuList
                this.mark = JSON.parse(objectItem).mark 
            },1)
        },
        methods:{
            //第一层
            goUrl(ev){

                //防止重复点击
                if(this.menuID*1==ev.id*1){
                    return
                }
                if(ev.webUrl==""){
                    //选中的ID值得组装
                    let navBtn =[...this.listMenuList,...[{menuID:ev.id,menuSonID:ev.childMBs[0].id,title:ev.childMBs[0].name,url:ev.childMBs[0].webUrl}]]
                    let parms = {
                        menuList:this.menuLists,              //切换的菜单
                        menuID: ev.id,                        //菜单主模块标志
                        menuSonID: ev.childMBs[0].id,         //菜单子模块标志
                        listMenuList:removal(navBtn),         //横向菜单
                        mark:this.mark                        //选中的平台
                    }
                    localStorage.setItem("menuBtnVav",JSON.stringify(parms)) 

                    //点击时候的跳转
                    this.$router.replace({
                        path:ev.childMBs[0].webUrl,
                        query:{}
                    })

                }else{
                    let navBtn =[...this.listMenuList,...[{menuID:ev.id,menuSonID:ev.id,title:ev.name,url:ev.webUrl}]]
                    let parms = {
                        menuList:this.menuLists,              //切换的菜单
                        menuID: ev.id,                        //菜单主模块标志
                        menuSonID: ev.id,                     //菜单子模块标志
                        listMenuList:removal(navBtn),         //横向菜单
                        mark:this.mark                        //选中的平台
                    }
                    localStorage.setItem("menuBtnVav",JSON.stringify(parms)) 
                    //点击时候的跳转
                    this.$router.replace({
                        path:ev.webUrl,
                        query:{}
                    })
                }
            },

            //第二层
            goUrlChild(ev){

                //防止重复点击
                if(this.menuSonID*1==ev.id){
                  return
                }
                let navBtn =[...this.listMenuList,...[{menuID:ev.parentId,menuSonID:ev.id,title:ev.name,url:ev.webUrl}]]
                let parms = {
                    menuList:this.menuLists,              //切换的菜单
                    menuID: ev.parentId,                  //菜单主模块标志
                    menuSonID: ev.id,                     //菜单子模块标志
                    listMenuList:removal(navBtn),         //横向菜单
                    mark:this.mark                        //选中的平台
                }
                localStorage.setItem("menuBtnVav",JSON.stringify(parms)) 
                this.$router.replace({
                    path:ev.webUrl,
                    query:{}
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .blockDiv{
        border-right: 1px solid rgba(213,217,227,0.4);
        overflow-y: auto;
        user-select:none; /* CSS3属性 */
        width: 100%;
        box-sizing: border-box;
        .warp-nav-btn{
            margin-bottom:16px;
            .imgBlockSvg{
                height: 33px;
                width: 38px;
                overflow: hidden;
                position: relative;
            }
            .nav-btn{
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                padding: 0 10px;
                box-sizing: border-box;
                background: #FFFFFF;
                box-shadow: 3px 5px 9px 0 rgba(205,216,233,0.39);
                border-radius: 6px;
                position: relative;
                .imgBlockSvg{
                    top:2px;
                }
                .svg-icon{
                    font-size:72px;
                    position: relative;
                    top: -22px;
                    right: 4px;
                }
                .wei{
                    right:41px;
                }
                i{
                    position: absolute;
                    top: 12px;
                    right: 11px;
                }
                .text{
                    display: block;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #4D5C72;
                    letter-spacing: 0;
                    margin-left:0px;
                    width: 66px;
                    overflow:hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow:ellipsis;
                }
            }
            .warp-list{
                 margin-top: 16px;
                 padding: 0 20px 0 10px;
                 box-sizing: border-box;
                 .imgBlockSvg{
                    top:2px;
                 }
                 .btnBlock{
                    margin-bottom: 14px;
                    cursor: pointer;
                 }
                 .btnBlock.btn{
                    margin-bottom:0px;
                 }
                 .textBtn{
                    height: 22px;
                    line-height: 22px;
                    .svg-icon{
                        font-size:72px;
                        position: relative;
                        top: -22px;
                        right: 5px;
                    }
                    .wei{
                        right:41px;
                    }
                    .btn-name{
                        display: inline-block;
                        margin-left:0px;
                        font-size: 14px;
                        color: #4D5C72;
                        position: relative;
                        top:1px;
                    }
                 }
                 .textBtn.active{
                    .btn-name{
                        color:  #458EFF!important;
                    }
                 } 
            }
        }
        .warp-nav-btn.active{
            .nav-btn{
                background-image: linear-gradient(270deg, #4AA7FF 0%, #246EFF 100%);
                box-shadow: 2px 2px 12px 0px rgba(66,155,255,0.55);
                color: #FFFFFF;
                .text{
                    color: #FFFFFF; 
                }
            }
        }
    }
 </style>